import { render, staticRenderFns } from "./turncases-approved.vue?vue&type=template&id=28a85547&scoped=true"
import script from "./turncases-approved.vue?vue&type=script&lang=ts"
export * from "./turncases-approved.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a85547",
  null
  
)

export default component.exports